"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dimensionsWithValuesList = exports.sortDimensionValues = void 0;
const date_fns_1 = require("date-fns");
const dimensions_1 = require("../dimensions");
const sortDimensionValues = (row) => row
    .tablePivot()
    .filter(obj => Object.values(obj)[0] && Object.values(obj)[1])
    .sort((a, b) => Number(Object.values(b)[1]) - Number(Object.values(a)[1]))
    .map(obj => Object.values(obj)[0].toString());
exports.sortDimensionValues = sortDimensionValues;
const dimensionsTitleMap = new Map(Object.entries(dimensions_1.dimensions).map(([title, key]) => [key, title]));
const blacklistedDimensions = [dimensions_1.dimensions['Landing page'], dimensions_1.dimensions['Ad Content']];
const dimensionsWithValuesList = (dateRange, disablePreaggregation = false) => ({
    mutexKey: `dimensionsWithValuesList:dateRange:${dateRange[0]}:${dateRange[1]}`,
    notPreaggregatedMeasures: Object.values(dimensions_1.dimensions)
        .filter(dimension => !blacklistedDimensions.includes(dimension))
        .map(() => 'Attribution.notPreaggregatedMeasure'),
    queries: Object.values(dimensions_1.dimensions)
        .filter(dimension => !blacklistedDimensions.includes(dimension))
        .map(dimension => ({
        dimensions: [dimension],
        measures: [
            'Attribution.clicks',
            ...(disablePreaggregation || new Date(dateRange[0]) < (0, date_fns_1.subDays)(new Date(), 92)
                ? ['Attribution.notPreaggregatedMeasure']
                : []),
        ],
        order: [['Attribution.clicks', 'desc']],
        filters: [
            {
                member: 'Attribution.date',
                operator: 'inDateRange',
                values: [dateRange[0], dateRange[1]],
            },
        ],
    })),
    resultProcessor: (rows) => {
        const resultMap = new Map(rows.map(row => {
            const tableColumns = row.tableColumns();
            return [
                tableColumns[0].key,
                {
                    key: tableColumns[0].key,
                    title: dimensionsTitleMap.get(tableColumns[0].key) || tableColumns[0].key,
                    values: (0, exports.sortDimensionValues)(row),
                },
            ];
        }));
        return Object.values(dimensions_1.dimensions).map(value => {
            const withValues = resultMap.get(value);
            if (withValues) {
                return withValues;
            }
            return {
                key: value,
                title: dimensionsTitleMap.get(value) || value,
                values: [],
            };
        });
    },
});
exports.dimensionsWithValuesList = dimensionsWithValuesList;
//# sourceMappingURL=dimensionsWithValuesList.js.map